<script setup lang="ts">
import { useRouter } from "vue-router";

import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();
const router = useRouter();

async function handleLogout(): Promise<void> {
  await auth.logout();
  await router.push("/");
}
</script>

<template>
  <header class="app-header">
    <RouterLink to="/" class="brand">
      <img src="@/rl_logo.svg" alt="" class="brand-mark" aria-hidden="true" />
      <span>RevisionLab</span>
    </RouterLink>
    <nav>
      <template v-if="auth.isAuthenticated">
        <RouterLink to="/catalogue">Catalogue</RouterLink>
        <RouterLink to="/account">My Courses</RouterLink>
        <RouterLink
          v-if="auth.hasPermission('admin.catalogue.read')"
          to="/admin"
          data-testid="nav-admin"
        >
          Admin
        </RouterLink>
        <span class="muted">{{ auth.user?.email }}</span>
        <button class="linklike" @click="handleLogout">Log out</button>
      </template>
      <template v-else>
        <RouterLink to="/login">Log in</RouterLink>
        <RouterLink to="/register">Register</RouterLink>
      </template>
    </nav>
  </header>
</template>
